const speed = 0.5; // lower = more fixed, higher = more movement

document.addEventListener("scroll", () => {
  const img = document.querySelector(".c-container .hero__media-wrapper img");
  if (!img) return;

  const scrollY = window.scrollY;

  img.style.objectPosition = `50% calc(50% + ${scrollY * speed}px)`;
});


document.addEventListener("scroll", () => {
  const hero = document.querySelector(".hero-2 .hero__container");
  const video = document.querySelector(".hero-2 .hero__video-wrapper--desktop video");

  if (!hero || !video) return;

  const rect = hero.getBoundingClientRect();

  // Only run when hero section is visible
  if (rect.bottom > 0 && rect.top < window.innerHeight) {
    const speed = 0.5; // lower = more fixed-like
    const offset = rect.top * -speed;

    video.style.objectPosition = `50% calc(50% + ${offset}px)`;
  }
});

// Run only when URL = ?customer_posted=true#contact_form
const isPosted =
  window.location.search.includes("customer_posted=true") &&
  window.location.hash.includes("contact_form");

if (isPosted) {
  const heroContainer = document.querySelector(".hero-2 .hero__container");
  const mediaWrapper = document.querySelector(".hero__media-wrapper");
  const contentWrapper = document.querySelector(".hero__content-wrapper");

  // 1) hero__media-wrapper → height: 100%
  if (mediaWrapper) {
    mediaWrapper.style.height = "100%";
  }

  // 2) hero__content-wrapper → height: 100vh, then change to 100%
  if (contentWrapper) {
    contentWrapper.style.height = "100vh";

    setTimeout(() => {
      contentWrapper.style.height = "100%";
    }, 1000);
  }

  // 3) heroContainer → overflow visible → hide after 1s
  if (heroContainer) {
    heroContainer.style.overflow = "visible";

    setTimeout(() => {
      heroContainer.style.overflow = "hidden";
    }, 1000);
  }
}
